import { BACKEND_URL } from "@/lib/backendUrl";
import axios from "axios";

export const VOLUNTEER_TOKEN_KEY = "servecor_volunteer_token";

export const volApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

volApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(VOLUNTEER_TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
